var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-box"},[_c('div',{staticClass:"c-box__header"},[_vm._t("header")],2),_c('div',{staticClass:"c-box__body"},[_vm._t("body")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }